module.exports = __webpack_public_path__ + "static/media/19.Waving Hand 2 (1).8eeb649d.gif";